<button routerLink="/auth/login" class="column" type="button" mat-button color="secondary">
  <mat-icon iconPositionStart>arrow_back</mat-icon>
  RECOVER YOUR PASSWORD
</button>

<form  [formGroup]="signupForm" class="validate-form" (ngSubmit)="changePassword()">
  <div class="column">
    <div class="FillInWithTheCodeSentToYourEmailAddress" style="width: 100%; color: #424242; font-size: 16px; font-family: Roboto; font-weight: 400; line-height: 28px; letter-spacing: 0.15px; word-wrap: break-word">Provide a password for your account</div>
  </div>
  <div class="column">
    <div class="row">
      <mat-form-field class="text-field" appearance="outline">
        <mat-label>New password</mat-label>
        <input matInput placeholder="New password" [type]="hide ? 'password' : 'text'" formControlName="password" required>
        <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
      </mat-form-field>
      <app-password-strength-validator [passwordToCheck]="signupForm.value.password??''" (passwordStrength)="onPasswordStrengthChanged($event)"></app-password-strength-validator>
    </div>
    <div class="row">
      <mat-form-field class="text-field" appearance="outline">
        <mat-label>New password confirmation</mat-label>
        <input matInput placeholder="New password confirmation" [type]="hideC ? 'password' : 'text'" formControlName="confirmPassword" required>
        <mat-icon matSuffix (click)="hideC = !hideC">{{hideC ? 'visibility_off' : 'visibility'}}</mat-icon>
      </mat-form-field>
      <mat-error class="passwords-error-message"  *ngIf="passwordMismatch">The password and confirmation do not match.
        Please ensure both fields contain the same password and try again
      </mat-error>
    </div>
  </div>
  <div class="row spacer"></div>
  <div class="submit-button">
    <button [disabled]="signupForm.invalid"  type="submit" mat-button>RESET PASSWORD
      <mat-icon iconPositionEnd>arrow_right_alt</mat-icon>
    </button>
  </div>
</form>
